// src/components/Invoice/ProfessionalVATInvoice.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  pdf,
  Image,
  BlobProvider,
} from "@react-pdf/renderer";
import img from '../images-src/logo.jpeg';

// PDF Styles
const pdfStyles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 8,
    fontFamily: "Helvetica",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    borderBottomWidth: 2,
    borderBottomColor: "#0891b2",
    paddingBottom: 20,
  },
  companyName: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#0891b2",
  },
  companyDetails: {
    fontSize: 9,
    color: "#333",
    marginTop: 2,
  },
  invoiceTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#0891b2",
    textAlign: "right",
  },
  subtitle0: {
    fontSize: 10,
    color: "#666",
    textAlign: "right",
    marginTop: 5,
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: 10,
    color: "#666",
    textAlign: "right",
    marginTop: 5,
  },
  infoSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 15,
    backgroundColor: "#ffffff",
    padding: 10,
  },
  infoBlock: {
    flex: 1,
    marginRight: 15,
  },
  infoLabel: {
    fontSize: 9,
    color: "#333",
    marginBottom: 2,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  infoValue: {
    fontSize: 11,
    fontWeight: "600",
    color: "#000",
  },
  customerSection: {
    marginBottom: 20,
    padding: 10,
    backgroundColor: "#ffffff",
  },
  table: {
    marginBottom: 20,
    borderWidth: 1,
    borderColor: "#ddd",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#0891b2",
    color: "white",
    padding: 10,
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    padding: 8,
  },
  tableRowAlt: {
    backgroundColor: "#f9f9f9",
  },
  col1: { width: "30%", paddingHorizontal: 5 },
  col2: { width: "8%", textAlign: "center", paddingHorizontal: 5 },
  col3: { width: "10%", textAlign: "center", paddingHorizontal: 5 },
  col4: { width: "12%", textAlign: "right", paddingHorizontal: 5 },
  col5: { width: "12%", textAlign: "right", paddingHorizontal: 5 },
  col6: { width: "10%", textAlign: "center", paddingHorizontal: 5 },
  col7: { width: "12%", textAlign: "right", paddingHorizontal: 5 },
  discountTotalRow: {
    flexDirection: "row",
    borderBottomWidth: 2,
    borderBottomColor: "#0891b2",
    backgroundColor: "#f3f4f6",
    padding: 8,
    fontWeight: "bold",
  },
  totals: {
    marginTop: 20,
    alignItems: "flex-end",
  },
  totalRow: {
    flexDirection: "row",
    padding: 5,
    width: "100%",
  },
  totalLabel: {
    flex: 1,
    textAlign: "right",
    marginRight: 10,
    fontSize: 11,
  },
  totalValue: {
    width: 100,
    textAlign: "right",
    fontSize: 11,
  },
  grandTotal: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#0891b2",
    borderTopWidth: 2,
    borderTopColor: "#0891b2",
    paddingTop: 10,
    marginTop: 5,
  },
  notes: {
    marginTop: 30,
    padding: 15,
    backgroundColor: "#f8f9fa",
    borderRadius: 5,
  },
  notesTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 8,
    color: "#0891b2",
  },
  notesText: {
    fontSize: 10,
    lineHeight: 1.4,
    color: "#666",
  },
  footer: {
    position: "absolute",
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: "center",
    color: "#666",
    fontSize: 9,
    borderTopWidth: 1,
    borderTopColor: "#ddd",
    paddingTop: 10,
  },
  compliance: {
    fontSize: 8,
    color: "#0891b2",
    marginTop: 5,
  },
  logo: {
    width: 30,
    height: 30,
  },
});

// PDF Document Component
const QuotationPDFDocument = ({ quotationData }) => {
  console.log('===== PDF DOCUMENT RENDER =====');
  console.log('Quotation Data Received in PDF:', quotationData);
  console.log('Quotation Number in PDF Document:', quotationData?.quotationNo);
  console.log('==============================');

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-AE", {
      style: "currency",
      currency: "AED",
      minimumFractionDigits: 2,
    }).format(amount || 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch {
      return dateString;
    }
  };

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        {/* Header */}
        <View style={pdfStyles.header}>
          <View>
            <Image src={img} style={{ width: 90, height: 110, marginBottom: 5, marginLeft: 100 }} />
          </View>
          <View>
            <Text style={pdfStyles.invoiceTitle}>QUOTATION</Text>
            <Text style={pdfStyles.subtitle0}>Diamond Quality Construction L.L.C.SP</Text>
            <Text style={pdfStyles.subtitle}>TRN: 104836477000001</Text>
            <Text style={pdfStyles.subtitle}>Sharjah - Muweilah - University City Street</Text>
            <Text style={pdfStyles.subtitle}>Office No.: 602-58 Floor No.: 6 - Al Areej</Text>
            <Text style={pdfStyles.subtitle}>0557001522</Text>
            <Text style={pdfStyles.subtitle}>dqcc01@gmail.com</Text>
            <Text style={pdfStyles.subtitle}>www.dqcc.ae</Text>
          </View>
        </View>

        {/* Quotation Info */}
        <View style={pdfStyles.infoSection}>
          <View style={pdfStyles.infoBlock}>
            <Text style={pdfStyles.infoLabel}>Quotation Number</Text>
            <Text style={pdfStyles.infoValue}>{quotationData.quotationNo}</Text>
          </View>
          <View style={pdfStyles.infoBlock}>
            <Text style={pdfStyles.infoLabel}>Quotation Date</Text>
            <Text style={pdfStyles.infoValue}>
              {formatDate(quotationData.quotationDate)}
            </Text>
          </View>
          <View style={pdfStyles.infoBlock}>
            <Text style={pdfStyles.infoLabel}>Quoted Amount</Text>
            <Text style={pdfStyles.infoValue}>
              {formatCurrency(quotationData.items?.reduce((sum, item) => {
                const subtotal = item.quantity * item.unit_price;
                const discountAmount = item.discount_amount;
                const afterDiscount = subtotal - discountAmount;
                const vatAmount = afterDiscount * (item.vat_percent / 100);
                return sum + afterDiscount + vatAmount;
              }, 0) || 0)}
            </Text>
          </View>
        </View>

        {/* Customer Details */}
        <View style={pdfStyles.customerSection}>
          <Text style={[pdfStyles.infoLabel, { marginBottom: 8 }]}>QUOTED FOR</Text>
          <Text
            style={[pdfStyles.infoValue, { marginTop: 3, marginBottom: 5 }]}
          >
            {quotationData.customerName}
          </Text>
          {quotationData.customerAddress && (
            <Text style={[pdfStyles.companyDetails, { marginBottom: 3 }]}>Address: {quotationData.customerAddress}</Text>
          )}
          {quotationData.customerTrn && (
            <Text style={[pdfStyles.companyDetails, { marginBottom: 3 }]}>TRN No.: {quotationData.customerTrn}</Text>
          )}
          {quotationData.customerPhone && (
            <Text style={pdfStyles.companyDetails}>Phone: {quotationData.customerPhone}</Text>
          )}
        </View>

        {/* Items Table */}
        <View style={pdfStyles.table}>
          <View style={pdfStyles.tableHeader}>
            <Text style={pdfStyles.col1}>ITEM DESCRIPTION</Text>
            <Text style={pdfStyles.col2}>QTY.</Text>
            <Text style={pdfStyles.col3}>UNIT</Text>
            <Text style={pdfStyles.col4}>PRICE</Text>
            <Text style={pdfStyles.col5}>DISCOUNT</Text>
            <Text style={pdfStyles.col6}>VAT %</Text>
            <Text style={pdfStyles.col7}>TOTAL</Text>
          </View>

          {quotationData.items.map((item, index) => {
            const subtotal = item.quantity * item.unit_price;
            const discountAmount = item.discount_amount;
            const afterDiscount = subtotal - discountAmount;
            const vatAmount = afterDiscount * (item.vat_percent / 100);
            const total = afterDiscount + vatAmount;

            return (
              <View
                key={index}
                style={[
                  pdfStyles.tableRow,
                  index % 2 === 1 ? pdfStyles.tableRowAlt : {},
                ]}
              >
                <Text style={pdfStyles.col1}>{item.description}</Text>
                <Text style={pdfStyles.col2}>{item.quantity}</Text>
                <Text style={pdfStyles.col3}>{item.unit || "each"}</Text>
                <Text style={pdfStyles.col4}>{formatCurrency(item.unit_price)}</Text>
                <Text style={pdfStyles.col5}>{formatCurrency(item.discount_amount)}</Text>
                <Text style={pdfStyles.col6}>{item.vat_percent || 0}%</Text>
                <Text style={pdfStyles.col7}>{formatCurrency(total)}</Text>
              </View>
            );
          })}
        </View>

        {/* Totals Section */}
        <View style={pdfStyles.totals}>
          <View style={pdfStyles.totalRow}>
            <Text style={pdfStyles.totalLabel}>Subtotal:</Text>
            <Text style={pdfStyles.totalValue}>
              {formatCurrency(quotationData.items?.reduce((sum, item) => {
                const subtotal = item.quantity * item.unit_price;
                return sum + subtotal;
              }, 0) || 0)}
            </Text>
          </View>
          <View style={pdfStyles.totalRow}>
            <Text style={pdfStyles.totalLabel}>Less: Discount:</Text>
            <Text style={pdfStyles.totalValue}>
              ({formatCurrency(quotationData.items?.reduce((sum, item) => {
                return sum + item.discount_amount;
              }, 0) || 0)})
            </Text>
          </View>
          <View style={pdfStyles.totalRow}>
            <Text style={pdfStyles.totalLabel}>Taxable Amount:</Text>
            <Text style={pdfStyles.totalValue}>
              {formatCurrency(quotationData.items?.reduce((sum, item) => {
                const subtotal = item.quantity * item.unit_price;
                const afterDiscount = subtotal - item.discount_amount;
                return sum + afterDiscount;
              }, 0) || 0)}
            </Text>
          </View>
          <View style={pdfStyles.totalRow}>
            <Text style={pdfStyles.totalLabel}>VAT (5%):</Text>
            <Text style={pdfStyles.totalValue}>
              {formatCurrency(quotationData.items?.reduce((sum, item) => {
                const subtotal = item.quantity * item.unit_price;
                const afterDiscount = subtotal - item.discount_amount;
                const vat = afterDiscount * (item.vat_percent / 100);
                return sum + vat;
              }, 0) || 0)}
            </Text>
          </View>
          <View style={[pdfStyles.totalRow, { borderTopWidth: 2, borderTopColor: "#0891b2", paddingTop: 10, marginTop: 5 }]}>
            <Text style={{ flex: 1, textAlign: "right", marginRight: 10, fontSize: 12, fontWeight: "bold", color: "#0891b2" }}>Quoted Amount: (AED)</Text>
            <Text style={[pdfStyles.totalValue, { fontWeight: "bold", fontSize: 12, color: "#0891b2" }]}>
              {formatCurrency(quotationData.items?.reduce((sum, item) => {
                const subtotal = item.quantity * item.unit_price;
                const afterDiscount = subtotal - item.discount_amount;
                const vat = afterDiscount * (item.vat_percent / 100);
                return sum + afterDiscount + vat;
              }, 0) || 0)}
            </Text>
          </View>
        </View>

        {/* Notes */}
        {quotationData.notes && (
          <View style={pdfStyles.notes}>
            <Text style={pdfStyles.notesTitle}>Terms & Conditions:</Text>
            <Text style={pdfStyles.notesText}>{quotationData.notes}</Text>
          </View>
        )}

        {/* Footer */}
        <View style={pdfStyles.footer}>
          <Text>This is a computer generated quotation</Text>
        </View>
      </Page>
    </Document>
  );
};

const ProfessionalVATQuotation = ({
  onSubmit = () => {},
  initialData,
  companyInfo = null,
}) => {
  // Helper function to format date for HTML input (YYYY-MM-DD)
  const formatDateForInput = (date) => {
    return date.toISOString().split('T')[0];
  };

  // Calculate default dates
  const today = new Date();

  const [formData, setFormData] = useState(
    initialData || {
      quotationNo: "[AUTO]",
      quotationDate: formatDateForInput(today),
      customerId: null,

      // Customer Information
      customerName: "",
      customerTrn: "",
      customerPhone: "",
      customerAddress: "",
      customerCity: "",
      customerCountry: "",

      // Line Items
      items: [
        {
          description: "Service1",
          quantity: 1,
          unit: "Unit",
          unit_price: 0,
          discount_amount: 0,
          vat_percent: 5,
        },
      ],

      // Notes
      notes: "",
    },
  );

  const [company] = useState(
    companyInfo || {
      name: "Diamond Quality Constructions",
      trn: "104836477000001",
      address: "Sharja, UAE",
      logo: "/logo.jpeg",
    },
  );

  const [items, setItems] = useState(formData.items);
  const [showCustomerForm, setShowCustomerForm] = useState(false);
  const [errors, setErrors] = useState({});
  const [pdfData, setPdfData] = useState(null);
  const [shouldDownload, setShouldDownload] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(false);
  const [apiDebugResponse, setApiDebugResponse] = useState(null);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;



  // UAE Emirates list
  const emirates = [
    "Abu Dhabi",
    "Dubai",
    "Sharjah",
    "Ajman",
    "Umm Al Quwain",
    "Ras Al Khaimah",
    "Fujairah",
  ];

  // Fetch customers from API
  useEffect(() => {
    const fetchCustomers = async () => {
      setCustomersLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/api/customers`);
        setCustomers(response.data);
      } catch (error) {
        console.error("Error fetching customers:", error);
        setCustomers([]);
      } finally {
        setCustomersLoading(false);
      }
    };

    fetchCustomers();
  }, [apiUrl]);

  // Calculate line item total
  const calculateItemTotal = (item) => {
    const subtotal = item.quantity * item.unit_price;
    const discountAmount = item.discount_amount;
    const afterDiscount = subtotal - discountAmount;
    const vatAmount = afterDiscount * (item.vat_percent / 100);
    return afterDiscount + vatAmount;
  };

  // Calculate totals
  const calculateTotals = () => {
    let subtotal = 0;
    let totalDiscount = 0;
    let taxableAmount = 0;
    let vatTotal = 0;

    items.forEach((item) => {
      const itemSubtotal = item.quantity * item.unit_price;
      const itemDiscount = item.discount_amount;
      const itemAfterDiscount = itemSubtotal - itemDiscount;
      const itemVat = itemAfterDiscount * (item.vat_percent / 100);

      subtotal += itemSubtotal;
      totalDiscount += itemDiscount;
      taxableAmount += itemAfterDiscount;
      vatTotal += itemVat;
    });

    const totalDue = taxableAmount + vatTotal;

    return {
      subtotal,
      totalDiscount,
      taxableAmount,
      vatTotal,
      totalDue,
    };
  };

  const { subtotal, totalDiscount, taxableAmount, vatTotal, totalDue } =
    calculateTotals();

  // Handle customer selection
  const handleCustomerSelect = (customerId) => {
    const customer = customers.find((c) => c.id === parseInt(customerId));
    if (customer) {
      setFormData({
        ...formData,
        customerId: customer.id,
        customerName: customer.name,
        customerTrn: customer.trn || "",
        customerPhone: customer.phone || "",
        customerAddress: customer.address || "",
        customerCity: customer.emirate || "",
        customerCountry: customer.country || "UAE",
      });
    }
  };

  // Add new item row
  const addItem = () => {
    setItems([
      ...items,
      {
        description: "",
        quantity: 1,
        unit: "Unit",
        unit_price: 0,
        discount_amount: 0,
        vat_percent: 5,
      },
    ]);
  };

  // Remove item row
  const removeItem = (index) => {
    if (items.length > 1) {
      const newItems = items.filter((_, i) => i !== index);
      setItems(newItems);
    }
  };

  // Update item field
  const updateItem = (index, field, value) => {
    const newItems = [...items];

    if (
      ["quantity", "unit_price", "discount_amount", "vat_percent"].includes(field)
    ) {
      newItems[index][field] = parseFloat(value) || 0;
    } else {
      newItems[index][field] = value;
    }

    setItems(newItems);
  };

  // Update form field
  const updateField = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  // Format date for display
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "/");
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.customerName)
      newErrors.customerName = "Customer name is required";
    // Quotation number is auto-generated by backend, no need to validate
    if (!formData.quotationDate) newErrors.quotationDate = "Quotation date is required";

    items.forEach((item, index) => {
      if (!item.description) {
        newErrors[`item_${index}_description`] = "Description required";
      }
      if (item.quantity <= 0) {
        newErrors[`item_${index}_quantity`] = "Quantity must be greater than 0";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Reset form to default values
  const resetForm = () => {
    const today = new Date();

    setFormData({
      quotationNo: "[AUTO]",
      quotationDate: formatDateForInput(today),
      customerId: null,
      customerName: "",
      customerTrn: "",
      customerPhone: "",
      customerAddress: "",
      customerCity: "",
      customerCountry: "",
      items: [],
      notes: "",
    });

    setItems([
      {
        description: "Service1",
        quantity: 1,
        unit: "Unit",
        unit_price: 0,
        discount_amount: 0,
        vat_percent: 5,
      },
    ]);

    setErrors({});
    setShowCustomerForm(false);
  };

  // Handle form submit - show modal first
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Store form data and show modal for user to choose action
      setPendingFormData({ items, formData });
      setShowSaveModal(true);
    }
  };

  // Handle actual quotation saving
  const saveQuotation = async (downloadPDF = false) => {
    setShowSaveModal(false);
    
    try {
      // Prepare API payload matching Laravel migrations
      const apiPayload = {
        customer_id: formData.customerId,
        // NOTE: DO NOT send quotation_no - Laravel backend generates it automatically
        // quotation_no will be generated server-side from the Lastid table
        quotation_date: formData.quotationDate,
        notes: formData.notes,
        items: items.map((item) => ({
          description: item.description,
          quantity: parseFloat(item.quantity) || 0,
          unit: item.unit,
          unit_price: parseFloat(item.unit_price) || 0,
          discount_amount: parseFloat(item.discount_amount) || 0,
          vat_percent: parseFloat(item.vat_percent) || 0,
        })),
      };

      // Send data to Laravel API
      const apiUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await axios.post(`${apiUrl}/api/quotations`, apiPayload);

      // Debug: log the full response to see structure
      console.log('===== API RESPONSE DEBUG =====');
      console.log('Full Response:', response);
      console.log('Response Status:', response.status);
      console.log('Response Data:', response.data);
      console.log('Response Data Keys:', Object.keys(response.data));
      
      // The Laravel backend returns the quotation object DIRECTLY or nested under 'quotation' key
      // First check if quotation is nested, otherwise use response.data directly
      let quotationFromResponse = response.data.quotation || response.data;
      console.log('Quotation Object from Response:', quotationFromResponse);
      
      if (quotationFromResponse) {
        console.log('Quotation Keys:', Object.keys(quotationFromResponse));
        console.log('Quotation quotation_no:', quotationFromResponse.quotation_no);
      }
      
      // Extract quotation number - the key field is 'quotation_no' (snake_case from Laravel)
      // The backend generates this as 'QT-' . str_pad($newQuotationId, 5, '0', STR_PAD_LEFT)
      let finalQuotationNo = '[AUTO]';
      if (quotationFromResponse && quotationFromResponse.quotation_no) {
        finalQuotationNo = quotationFromResponse.quotation_no;
        console.log('✓ SUCCESS: Got quotation_no:', finalQuotationNo);
      } else {
        console.error('✗ FAILED: Could not find quotation_no in response');
        console.error('Quotation object:', quotationFromResponse);
      }
      
      console.log('Final Quotation Number to Use:', finalQuotationNo);
      console.log('=============================');

      // Store API response for debugging
      setApiDebugResponse(response.data);

      // Update quotation number from API response - synchronously for display
      setFormData(prevData => ({
        ...prevData,
        quotationNo: finalQuotationNo
      }));

      // Prepare display data for PDF and onSubmit callback using actual quotation number
      const quotationData = {
        ...formData,
        quotationNo: finalQuotationNo,
        items: items,
        company: company,
        totals: { subtotal, totalDiscount, taxableAmount, vatTotal, totalDue },
        formattedDates: {
          quotationDate: formatDateForDisplay(formData.quotationDate),
        },
        apiPayload: apiPayload,
        apiResponse: response.data,
      };

      // Prepare PDF data with actual quotation number
      const pdfQuotationData = {
        ...formData,
        quotationNo: finalQuotationNo,
        items: items,
        company: company,
        totals: { subtotal, totalDiscount, taxableAmount, vatTotal, totalDue },
      };

      console.log('===== BEFORE PDF TRIGGER =====');
      console.log('finalQuotationNo value:', finalQuotationNo);
      console.log('pdfQuotationData.quotationNo:', pdfQuotationData.quotationNo);
      console.log('quotationData.quotationNo:', quotationData.quotationNo);
      console.log('Complete pdfQuotationData:', pdfQuotationData);
      console.log('PDF Download Enabled:', downloadPDF);
      console.log('==============================');

      // Set PDF data and trigger download only if user selected the option
      if (downloadPDF) {
        setPdfData(pdfQuotationData);
        setShouldDownload(true);
        
        console.log('===== AFTER setPdfData CALLED =====');
        console.log('State updates scheduled (async)');
        console.log('====================================');
      }

      // If onSubmit is provided and not the default empty function, use it
      if (onSubmit && onSubmit !== (() => {})) {
        onSubmit(quotationData);
      } else {
        // Default behavior: show success message
        if (downloadPDF) {
          alert("Quotation saved successfully! PDF will be downloaded automatically.");
        } else {
          // Show custom success modal for "Save Quotation Only"
          setSuccessMessage(finalQuotationNo);
        }
      }
    } catch (error) {
      console.error('Error saving quotation:', error);
      alert('Error saving quotation. Please try again.');
      }
    };

  // Effect to handle PDF download
  useEffect(() => {
    if (shouldDownload && pdfData) {
      console.log('===== PDF DOWNLOAD EFFECT TRIGGERED =====');
      console.log('shouldDownload:', shouldDownload);
      console.log('pdfData.quotationNo:', pdfData.quotationNo);
      console.log('PDF Filename:', `Quotation-${pdfData.quotationNo || "New"}.pdf`);
      console.log('Full pdfData:', pdfData);
      console.log('=========================================');

      // Generate and download PDF
      const generateAndDownloadPDF = async () => {
        try {
          console.log('Starting PDF generation...');
          console.log('pdfData passed to QuotationPDFDocument:', pdfData);
          
          const blob = await pdf(
            <QuotationPDFDocument quotationData={pdfData} />,
          ).toBlob();
          
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `Quotation-${pdfData.quotationNo || "New"}.pdf`;
          link.download = fileName;
          
          console.log('PDF Generated Successfully');
          console.log('PDF Filename:', fileName);
          console.log('Triggering download...');
          
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);

          console.log('PDF Download Completed');

          // Reset the trigger
          setShouldDownload(false);
          setPdfData(null);
        } catch (error) {
          console.error("Error generating PDF:", error);
          alert("Error generating PDF. Please try again.");
          setShouldDownload(false);
          setPdfData(null);
        }
      };

      generateAndDownloadPDF();
    }
  }, [shouldDownload, pdfData]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5 p-6">
       
      <div className="max-w-7xl mx-auto">
        {/* Header with animated gradient */}
        <div className="bg-[#23A19B] rounded-t-2xl p-8 text-white shadow-xl">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-4xl font-bold mb-2">Quotation Generator</h1>
              {/* <p className="text-white/80">Professional Quotation | UAE Tax Compliant</p> */}
            </div>
            <div className="badge badge-lg bg-white/20 text-white border-0 p-4">
              <span className="text-2xl font-bold">📋</span>
            </div>
          </div>
        </div>

        {/* Main Form Card */}
        <div className="bg-base-100 rounded-b-2xl shadow-2xl p-8 mb-8 border-t-4 border-primary">
          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Quotation Details Section */}
            <div className="bg-gradient-to-r from-primary/10 to-secondary/10 p-6 rounded-xl">
              <h3 className="text-xl font-bold text-primary mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-primary rounded-full"></span>
                Quotation Information
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold flex items-center gap-1">
                      <span className="text-primary">📄</span> QUOTATION NO.
                    </span>
                  </label>
                  <input
                    type="text"
                    className={`input input-bordered border-2 focus:border-primary bg-base-200 cursor-not-allowed ${errors.quotationNo ? "input-error" : ""}`}
                    value={formData.quotationNo}
                    readOnly
                    placeholder="[AUTO]"
                  />
                </div>

                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold flex items-center gap-1">
                      <span className="text-secondary">📅</span> QUOTATION DATE *
                    </span>
                  </label>
                  <input
                    type="date"
                    className={`input input-bordered border-2 focus:border-secondary ${errors.quotationDate ? "input-error" : ""}`}
                    value={formData.quotationDate}
                    onChange={(e) => updateField("quotationDate", e.target.value)}
                  />
                  {errors.quotationDate && <span className="text-error text-sm mt-1">{errors.quotationDate}</span>}
                </div>
              </div>
            </div>

            {/* Customer Section */}
            <div className="bg-gradient-to-r from-secondary/10 to-accent/10 p-6 rounded-xl">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-secondary flex items-center gap-2">
                  <span className="w-1 h-6 bg-secondary rounded-full"></span>
                  Quotation For — Customer
                </h3>
                <button
                  type="button"
                  className="btn btn-sm btn-outline btn-secondary"
                  onClick={() => setShowCustomerForm(!showCustomerForm)}
                >
                  {showCustomerForm ? "📋 Select Customer" : "➕ Add New"}
                </button>
              </div>

              {!showCustomerForm ? (
                <div className="form-control mb-4">
                  {customersLoading ? (
                    <div className="flex items-center gap-2">
                      <span className="loading loading-spinner loading-sm"></span>
                      Loading customers...
                    </div>
                  ) : customers.length > 0 ? (
                    <select
                      className="select select-bordered border-2"
                      onChange={(e) => handleCustomerSelect(e.target.value)}
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select a customer
                      </option>
                      {customers.map((customer) => (
                        <option key={customer.id} value={customer.id}>
                          {customer.name} - {customer.trn || "No TRN"}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <div className="text-sm text-gray-500">
                      No customers available. Add a new customer or check your connection.
                    </div>
                  )}
                </div>
              ) : null}

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold">
                      CUSTOMER NAME *
                    </span>
                  </label>
                  <input
                    type="text"
                    className={`input input-bordered border-2 ${errors.customerName ? "input-error" : ""}`}
                    value={formData.customerName}
                    readOnly
                    placeholder=""
                  />
                </div>

                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold">
                      TRN (TAX REG. NO.)
                    </span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered border-2 font-mono"
                    value={formData.customerTrn}
                    readOnly
                    placeholder="15-digit TRN"
                    maxLength="15"
                  />
                </div>

                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold">PHONE</span>
                  </label>
                  <input
                    type="tel"
                    className="input input-bordered border-2"
                    value={formData.customerPhone}
                    onChange={(e) =>
                      updateField("customerPhone", e.target.value)
                    }
                    placeholder="+971 50 123 4567"
                  />
                </div>

                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold">ADDRESS</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered border-2"
                    value={formData.customerAddress}
                    onChange={(e) =>
                      updateField("customerAddress", e.target.value)
                    }
                    placeholder="Street, Area"
                  />
                </div>

                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold">
                      CITY / EMIRATE
                    </span>
                  </label>
                  <select
                    className="select select-bordered border-2 bg-base-200 cursor-not-allowed opacity-75"
                    value={formData.customerCity}
                    disabled
                  >
                    <option value="">{formData.customerCity || "Select..."}</option>
                    {emirates.map((emirate) => (
                      <option key={emirate} value={emirate}>
                        {emirate}
                      </option>
                    ))}
                  </select>
                  <p className="text-xs text-gray-500 mt-1">Auto-filled from customer profile</p>
                </div>

                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold">COUNTRY</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered border-2"
                    value={formData.customerCountry}
                    readOnly
                    placeholder="UAE"
                  />
                </div>
              </div>
            </div>

            {/* Line Items Section */}
            <div className="bg-gradient-to-r from-accent/10 to-primary/10 p-6 rounded-xl">
              <h3 className="text-xl font-bold text-accent mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-accent rounded-full"></span>
                Line Items
              </h3>

              <div className="overflow-x-auto">
                <table className="table table-zebra w-full">
                  <thead className="bg-gradient-to-r from-primary to-secondary text-white">
                    <tr>
                      <th className="rounded-tl-lg">#</th>
                      <th>DESCRIPTION</th>
                      <th>QTY</th>
                      <th>UNIT</th>
                      <th>UNIT PRICE</th>
                      <th>DISC</th>
                      <th>VAT %</th>
                      <th className="rounded-tr-lg">TOTAL</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => {
                      const itemTotal = calculateItemTotal(item);

                      return (
                        <tr
                          key={index}
                          className="hover:bg-base-200 transition-colors"
                        >
                          <td className="font-bold text-primary">
                            {index + 1}
                          </td>
                          <td>
                            <input
                              type="text"
                              className="input input-bordered input-sm w-40"
                              value={item.description}
                              onChange={(e) =>
                                updateItem(index, "description", e.target.value)
                              }
                              placeholder="Description"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="input input-bordered input-sm w-16"
                              value={item.quantity}
                              onChange={(e) =>
                                updateItem(index, "quantity", e.target.value)
                              }
                              min="1"
                              step="0.01"
                            />
                          </td>
                          <td>
                            <select
                              className="select select-bordered select-sm w-20"
                              value={item.unit}
                              onChange={(e) =>
                                updateItem(index, "unit", e.target.value)
                              }
                            >
                              <option>Unit</option>
                              <option>Hour</option>
                              <option>Day</option>
                              <option>Service</option>
                              <option>Piece</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="number"
                              className="input input-bordered input-sm w-20"
                              value={item.unit_price}
                              onChange={(e) =>
                                updateItem(index, "unit_price", e.target.value)
                              }
                              min="0"
                              step="0.01"
                            />
                          </td>
                          <td>
                            <div className="relative">
                              <input
                                type="number"
                                className="input input-bordered input-sm w-16"
                                value={item.discount_amount}
                                onChange={(e) =>
                                  updateItem(
                                    index,
                                    "discount_amount",
                                    e.target.value,
                                  )
                                }
                                min="0"
                                step="0.01"
                              />
                            </div>
                          </td>
                          <td>
                            <select
                              className="select select-bordered select-sm w-16"
                              value={item.vat_percent}
                              onChange={(e) =>
                                updateItem(index, "vat_percent", e.target.value)
                              }
                            >
                              <option value="0">0%</option>
                              <option value="5">5%</option>
                            </select>
                          </td>
                          <td className="text-right font-mono font-bold text-success">
                            AED {itemTotal.toFixed(2)}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-ghost btn-xs text-error hover:bg-error/20"
                              onClick={() => removeItem(index)}
                              disabled={items.length === 1}
                            >
                              ✕
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <button
                type="button"
                className="btn btn-outline btn-accent btn-sm mt-4 hover:scale-105 transition-transform"
                onClick={addItem}
              >
                ➕ Add Line Item
              </button>
            </div>

            {/* Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="stat bg-gradient-to-br from-info/20 to-info/5 rounded-xl">
                <div className="stat-figure text-info">
                  <span className="text-2xl">💰</span>
                </div>
                <div className="stat-title">Subtotal</div>
                <div className="stat-value text-info text-2xl">
                  AED {subtotal.toFixed(2)}
                </div>
              </div>

              <div className="stat bg-gradient-to-br from-warning/20 to-warning/5 rounded-xl">
                <div className="stat-figure text-warning">
                  <span className="text-2xl">🏷️</span>
                </div>
                <div className="stat-title">Discount</div>
                <div className="stat-value text-warning text-2xl">
                  AED {totalDiscount.toFixed(2)}
                </div>
              </div>

              <div className="stat bg-gradient-to-br from-secondary/20 to-secondary/5 rounded-xl">
                <div className="stat-figure text-secondary">
                  <span className="text-2xl">🧾</span>
                </div>
                <div className="stat-title">VAT (5%)</div>
                <div className="stat-value text-secondary text-2xl">
                  AED {vatTotal.toFixed(2)}
                </div>
              </div>

              <div className="stat bg-gradient-to-br from-success/20 to-success/5 rounded-xl">
                <div className="stat-figure text-success">
                  <span className="text-2xl">💵</span>
                </div>
                <div className="stat-title">Total Due</div>
                <div className="stat-value text-success text-2xl">
                  AED {totalDue.toFixed(2)}
                </div>
              </div>
            </div>

            {/* Company Info and VAT Checklist */}
           

              {/* VAT Checklist */}
            

            {/* Notes & Bank Details */}
            <div className="grid grid-cols-1 gap-6">
              <div className="bg-gradient-to-br from-info/10 to-info/5 p-6 rounded-xl">
                <label className="label">
                  <span className="label-text font-bold text-info text-lg flex items-center gap-2">
                    <span className="w-1 h-6 bg-info rounded-full"></span>
                    NOTES / TERMS
                  </span>
                </label>
                <textarea
                  className="textarea textarea-bordered h-32 w-full border-2 focus:border-info"
                  value={formData.notes}
                  onChange={(e) => updateField("notes", e.target.value)}
                  placeholder=""
                ></textarea>
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex justify-end gap-4 pt-6 border-t">
              <button
                type="button"
                className="btn btn-ghost btn-lg hover:bg-base-200"
                onClick={() => window.history.back()}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-lg bg-gradient-to-r from-primary to-secondary border-0 hover:scale-105 transition-transform shadow-lg"
              >
                💾 Save Quotation
              </button>
            </div>
          </form>
        </div>

        {/* Hidden PDF Download Link */}
        {pdfData && (
          <div style={{ display: "none" }}>
            <PDFDownloadLink
              document={<QuotationPDFDocument quotationData={pdfData} />}
              fileName={`Quotation-${pdfData.quotationNo || "New"}.pdf`}
            >
              {({ loading }) => !loading && "Download PDF"}
            </PDFDownloadLink>
          </div>
        )}

        {/* Footer */}
        <div className="text-center text-sm text-base-500 mt-4">
          <p>
            🇦🇪 UAE Tax Compliant | Professional Quotation
          </p>
        </div>

        {/* DEBUG: API Response Display */}
        {/* {apiDebugResponse && (
          <div className="mt-8 p-6 bg-gray-900 text-green-400 rounded-lg font-mono text-xs overflow-auto max-h-96">
            <div className="mb-3 flex justify-between items-center">
              <div className="font-bold text-lg text-green-300">📋 API Response (Debugging):</div>
              <button
                type="button"
                onClick={() => setApiDebugResponse(null)}
                className="btn btn-sm btn-ghost text-red-400 hover:text-red-600"
              >
                ✕ Close
              </button>
            </div>
            <pre className="whitespace-pre-wrap break-words">
              {JSON.stringify(apiDebugResponse, null, 2)}
              
            </pre>
          </div>
        )} */}

        {/* Save Options Modal */}
        {showSaveModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full mx-4">
              <div className="mb-6">
                <h2 className="text-2xl font-bold text-primary mb-2">Save Quotation</h2>
                <p className="text-gray-600">What would you like to do?</p>
              </div>

              <div className="space-y-4">
                {/* Option 1: Save Only */}
                <button
                  onClick={() => saveQuotation(false)}
                  className="w-full btn btn-outline btn-lg border-2 border-primary text-primary hover:bg-primary hover:border-primary"
                >
                  <span className="text-xl mr-2">💾</span>
                  Save Quotation Only
                </button>

                {/* Option 2: Save & Print PDF */}
                <button
                  onClick={() => saveQuotation(true)}
                  className="w-full btn btn-primary btn-lg bg-gradient-to-r from-primary to-secondary border-0"
                >
                  <span className="text-xl mr-2">📄</span>
                  Save & Print PDF
                </button>
              </div>

              <div className="mt-6 pt-6 border-t text-center">
                <button
                  onClick={() => setShowSaveModal(false)}
                  className="btn btn-ghost btn-sm"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Success Message Modal */}
        {successMessage && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full mx-4">
              <div className="mb-6 text-center">
                <div className="text-6xl text-success mb-4">✓</div>
                <h2 className="text-2xl font-bold text-success mb-2">Quotation Saved Successfully</h2>
                <p className="text-lg text-primary font-semibold">
                  Quotation No: <span className="text-secondary font-bold">{successMessage}</span> has been saved
                </p>
              </div>

              <div className="mt-6 text-center">
                <button
                  onClick={() => {
                    setSuccessMessage(null);
                    setFormData(prevData => ({
                      ...prevData,
                      quotationNo: "[AUTO]"
                    }));
                  }}
                  className="btn btn-primary btn-lg"
                >
                  Create New Quotation
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{``}</style>
    </div>
  );
};

export default ProfessionalVATQuotation;
